import React, { Fragment, Component } from 'react'

import getLabels from '../../utils/getLabels'

import FlightMetaData from '../../containers/FlightMetaData'
import EditBookingForm from '../../containers/EditBookingForm'
import AdditionalNotesForm from '../../containers/AdditionalNotesForm'
import DeletePassengersOverview from '../../containers/DeletePassengersOverview'
import CustomTourOperator from '../../containers/TourOperator/CustomTourOperator'

import Modal from '../Modal'
import Spinner from '../Spinner'
import PageHeader from '../PageHeader'
import BackButton from '../BackButton'

import styles from './EditBooking.module.scss'
import globalStyles from '../../styles/global.module.scss'

interface EditBookingPropsInterface {
  requestSSRs: Function
  requestFlight: Function
  fetchPassengers: Function

  departureFlightId: string

  isTOFlight: boolean
  isFlightLoaded: boolean
  isSpecialSSRModalOpen: boolean
}

export default class EditBooking extends Component<EditBookingPropsInterface> {
  componentDidMount() {
    const {
      departureFlightId,
      requestSSRs,
      requestFlight,
      fetchPassengers,
    } = this.props

    requestSSRs(departureFlightId)
    requestFlight(departureFlightId)
    fetchPassengers(departureFlightId)
  }

  private readonly _renderForm = () => {
    const { isTOFlight, departureFlightId } = this.props

    return (
      <div
        className={`${globalStyles['page-item']} ${styles['form-container']}`}
      >
        <div className={styles['form-container-inner']}>
          <h2 className={styles['title']}>{getLabels('edit_booking_title')}</h2>

          <div className={styles['form-wrapper']}>
            <EditBookingForm
              isTOFlight={isTOFlight}
              flightId={departureFlightId}
            />
          </div>
        </div>
      </div>
    )
  }

  render() {
    const {
      departureFlightId,
      isFlightLoaded,
      isSpecialSSRModalOpen,
    } = this.props

    const mainContent = isFlightLoaded ? (
      this._renderForm()
    ) : (
      <div className={styles['spinner-container']}>
        <Spinner />
      </div>
    )

    return (
      <Fragment>
        <PageHeader>
          <div className={styles['controls']}>
            <BackButton />

            <CustomTourOperator />
          </div>

          <div className={styles['meta-data-container']}>
            <div className={styles['meta-data']}>
              <FlightMetaData
                flightId={departureFlightId}
                showPassengers={true}
              />
            </div>
          </div>
        </PageHeader>

        <div className={styles['main-content-wrapper']}>{mainContent}</div>

        <DeletePassengersOverview flightId={departureFlightId} />

        {isSpecialSSRModalOpen && (
          <Modal isOpen={true}>
            <AdditionalNotesForm />
          </Modal>
        )}
      </Fragment>
    )
  }
}
